import { createSelector } from '@reduxjs/toolkit';

import { type Service } from 'schemas';
import { type ReduxSelector } from 'store/store.types';
import { SERVICES_SLICE_NAME } from '../slicesNames';
import * as selectResults from '../results/selectResults';

export const isLoading: ReduxSelector<boolean> = (state) => state[SERVICES_SLICE_NAME].isLoading;
export const error: ReduxSelector<string | null> = (state) => state[SERVICES_SLICE_NAME].error;
export const all: ReduxSelector<Record<Service['serviceId'], Service>> = (state) =>
  state[SERVICES_SLICE_NAME].services;
export const nameMap: ReduxSelector<Record<Service['serviceName'], Service>> = (state) =>
  state[SERVICES_SLICE_NAME].nameMap;

/** Returns the service with the matching id */
export function byId(id: Service['serviceId']): ReduxSelector<Service | undefined> {
  return (state) => state[SERVICES_SLICE_NAME].services[id];
}

/** Returns the service matching the service id stored in the results slice */
export const current: ReduxSelector<Service | undefined> = createSelector(
  [selectResults.serviceId, all],
  (currentServiceId, allServices) => allServices[currentServiceId]
);

/** Returns the service with the matching name, case insensitive */
export function byName(name: Service['serviceName']): ReduxSelector<Service | undefined> {
  return (state) => state[SERVICES_SLICE_NAME].nameMap[name.toLowerCase()];
}
